"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _i18n = require("@lce/i18n");

var _slice = require("@lce/slice");

var Styled = _interopRequireWildcard(require("./AppBadges.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var AppBadges = function AppBadges(_a) {
  var apple = _a.apple,
      google = _a.google;
  var t = (0, _i18n.useTranslation)()[0];
  return React.createElement(_slice.Flex, {
    alignItems: "center",
    flexDirection: ['column', 'row'],
    width: [1, 'auto']
  }, React.createElement(_slice.Box, {
    mr: [0, 3],
    mb: [2, 0]
  }, React.createElement(Styled.AppBadgeText, {
    as: "h2"
  }, t('Footer.Mobile App'))), apple && React.createElement(_slice.Box, {
    mr: [0, 1],
    mb: [2, 0]
  }, React.createElement(Styled.AppBadgeLink, {
    "data-testid": "footer__apple-app-store",
    href: apple.link,
    title: apple.title,
    target: "_blank"
  }, React.createElement(apple.badge, null))), google && React.createElement(_slice.Box, null, React.createElement(Styled.AppBadgeLink, {
    "data-testid": "footer__google-play-store",
    href: google.link,
    title: google.title,
    target: "_blank"
  }, React.createElement(google.badge, null))));
};

var _default = AppBadges;
exports["default"] = _default;